import HeroNosotros from "./subComponents/HeroNosotros";
import HistoriaNosotros from "./subComponents/HistoriaNosotros";
import ContactoBanner from "../Inicio/subComponents/ContactoBanner"
import SEO from "../SEO/SEO";


const Nosotros = () => {

    return(
        <>
            <SEO
                title="Nosotros | Whisky And Co"
                description="Conoce quienes somos, donde estamos y como contactarnos en Whisky&Co."
                canonicalPath="/nosotros"
            />

            <HeroNosotros />
            <HistoriaNosotros />
            <ContactoBanner />

        </>
    )
};

export default Nosotros;